// Styles
import "./collections-slider.scss";

if (!window.dAgency) window.dAgency = {};

window.dAgency.initCollectionsSlider = (rootEl) => {
  new Swiper(rootEl.querySelector(".swiper-container"), {
    slidesPerView: 1.15,
    navigation: {
      nextEl: rootEl.querySelector(".next"),
      prevEl: rootEl.querySelector(".prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 2.15,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 2,
      },
    },
  });
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll(".collections-slider"), (el) => {
    window.dAgency.initCollectionsSlider(el);
  });
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(document.querySelectorAll(".collections-slider"), (el) => {
      window.dAgency.initCollectionsSlider(el);
    });
  });
}
